import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { abbreviateNumber } from 'app/utils/numbers';
import { userProps } from 'app/utils/propValidation';
import { usePrice } from 'modules/wallet/price.context';
import { Image, Row, NumericalValue, SecondaryText, Text } from 'modules/styled';
import { useRelBalance, useSRelBalance } from 'app/web3/hooks';
import { formatUnits } from 'app/web3/utils';
// import { userOnline } from 'app/core/actions';

const coinImage = require('public/img/relevantcoin.png');

function CoinStat(props) {
  const {
    user,
    isOwner,
    wallet,
    size = 3,
    amount,
    mr,
    align,
    noNumber,
    secondary,
    fs,
    lh,
    inline,
    c,
    spaceBetween,
    showPrice,
    noSpace,
    ...rest
  } = props;

  // const relBalance = useRelBalance();
  // const sRelBalanace = useSRelBalance();

  let tokens;
  if (typeof amount === 'number') tokens = amount;
  else if (user) {
    tokens = user.balance + user.pendingCashout;
    if (user.fullTokenBalance) tokens += user.fullTokenBalance;
  }
  const usdValue = usePrice(tokens);

  // if (isOwner && user.ethAddress && user.ethAddress[0] && relBalance && sRelBalanace) {
  //   tokens = user.balance + parseFloat(formatUnits(relBalance?.add(sRelBalanace)));
  // }

  const NumberStyle = secondary ? SecondaryText : NumericalValue;
  const imageMargin = align === 'center' ? -1 : 1;
  const Wrapper = inline ? Text : Row;

  let spacer = typeof spaceBetween == 'number' ? spaceBetween : size;

  return (
    <Wrapper
      {...rest}
      sx={{
        alignItems: align || 'center',
        mr: mr === 'number' ? mr : inline ? 0 : 1.5,
      }}
    >
      <Image
        source={coinImage}
        sx={{
          height: size,
          width: size,
          transform: [{ translateY: imageMargin }],
        }}
        resizeMode="contain"
      />

      {noNumber ? null : (
        <NumberStyle
          sx={{ color: c, fontSize: 8.001 * fs || 2, lineHeight: 8.001 * lh || 2 }}
        >
          {noSpace ? '' : ' '}
          <Row sx={{ width: spacer + 0.0001, height: 0 }} />
          {abbreviateNumber(tokens)}
          {showPrice ? usdValue : ''}
        </NumberStyle>
      )}
    </Wrapper>
  );
}

CoinStat.propTypes = {
  lh: PropTypes.number,
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  secondary: PropTypes.bool,
  mr: PropTypes.number,
  fs: PropTypes.number,
  amount: PropTypes.number,
  size: PropTypes.number,
  user: userProps,
  isOwner: PropTypes.bool,
  wallet: PropTypes.object,
  align: PropTypes.string,
  lineheight: PropTypes.string,
  c: PropTypes.string,
  noNumber: PropTypes.bool,
  spaceBetween: PropTypes.number,
  showPrice: PropTypes.bool,
  noSpace: PropTypes.bool,
};

export default memo(CoinStat);
